import React from 'react'
import { useUsers } from '../../hooks/useUsers'
import { ControlledAutocompleteField } from '../ControlledAutocompleteField/ControlledAutocompleteField'
import { useDebounce } from '@react-hook/debounce'

export const BrandSelect = ({ disabled }) => {
  const [inputValue, setInputValue] = useDebounce('', 300, true)
  const { data, isLoading } = useUsers('brand', inputValue)

  let menuItems = []
  if (isLoading) {
    menuItems = [
      {
        label: 'Loading...',
        value: ''
      }
    ]
  }

  if (data === undefined) {
    menuItems = [
      {
        label: 'No data found',
        value: ''
      }
    ]
  }

  menuItems = data?.reduce((ac, item) => {
    ac.push({ label: item.brandName, value: item._id })
    return ac
  }, [])

  const handleInputValueChange = (event, newInputValue) => {
    setInputValue(newInputValue)
  }

  return (
    <ControlledAutocompleteField
      options={menuItems}
      label='Brand'
      name='campaign.brand'
      inputValue={inputValue}
      onInputChange={handleInputValueChange}
      isLoading={isLoading}
      disabled={disabled}
    />
  )
}
